interface IURL {
  REDIRECT_URL: string;
  API_BASE_URL: string;
}

const dev = {
  REDIRECT_URL: "https://localhost:8000/v1",
  API_BASE_URL: "https://backend.bmhm.org/v1"
};

const prod = {
  REDIRECT_URL: "https://bmhm.vercel.app",
  API_BASE_URL: "https://backend.bmhm.org/v1"
};

const getEnv = (): IURL => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    default:
      return dev;
  }
};

export const env = getEnv();
